function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';

const EtherscanLink = ({
  address = '-',
  network = 'mainnet',
  className = '',
  style = {},
  isTokenTransfer,
  ...props
}) => {
  const urls = new Map([['ropsten', 'https://ropsten.etherscan.io'], ['rinkeby', 'https://rinkeby.etherscan.io'], ['kovan', 'https://kovan.etherscan.io'], ['mainnet', 'https://etherscan.io']]);
  let href;
  isTokenTransfer ? href = address => `${urls.get(network)}/search?f=0&q=${address}#tokentxns` : href = address => `${urls.get(network)}/search?f=0&q=${address}`;
  return ['-', '0x0000000000000000000000000000000000000000'].includes(address) ? /*#__PURE__*/React.createElement("div", _extends({
    className: className,
    style: style
  }, props), "-") : /*#__PURE__*/React.createElement("a", _extends({
    rel: "noopener noreferrer",
    target: "_blank",
    href: href(address),
    className: `link etherscanLink ${className}`,
    style: style
  }, props), address);
};

EtherscanLink.propTypes = {
  address: PropTypes.string,
  network: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
};
export default EtherscanLink;